import { acceptDeclineProposalTutorial } from '../../../../../img/images';
import { ILocalization } from '../../../../../localization/definitions/types';
import { InstructionTickIcon } from '../../../../shared/icons/icons';

interface Props {
    localization: ILocalization;
}

export const ApproveDeclineProjectSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='approve-decline-project-slide'>
                <img alt='' src={acceptDeclineProposalTutorial} />
            </div>
        </div>
    );
};

export const ApproveDeclineProjectSlideImageSrc = acceptDeclineProposalTutorial;

export const ApproveDeclineProjectSlideContent = ({ localization }: Props) => {
    const { approveDeclineProjectSlideContent } =
        localization.localizationStrings.susy.thesisManagement.tutorial
            .supervisor.slides;

    return (
        <div className='tutorial-content-wrapper' data-testid='third-slide'>
            <h1>{approveDeclineProjectSlideContent.approveOrDecline}</h1>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {approveDeclineProjectSlideContent.youWillReceive}{' '}
                    <span className='badge thesisOverview-card-badge mb-0 thesisOverview-card-badge-pending'>
                        {approveDeclineProjectSlideContent.pending}
                    </span>
                    .
                    <div />
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    <span className='instruction-content-bold'>
                        {approveDeclineProjectSlideContent.approve}{' '}
                    </span>{' '}
                    {approveDeclineProjectSlideContent.proposalsOr}
                    <div />
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    <span className='instruction-content-bold'>
                        {approveDeclineProjectSlideContent.decline}{' '}
                    </span>
                    {approveDeclineProjectSlideContent.andSpecify}
                    <div />
                </div>
            </div>
        </div>
    );
};
